import { Component, LOCALE_ID, computed, inject, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { isValidTimezone } from '@vendasta/galaxy/utility/timezone';
import {
  AppointmentBooking,
  getAppointmentStatusKey,
} from '../../../../../../core/src/lib/interface/appointment-message';

const MILLISECONDS_PER_SECOND = 1000;

@Component({
  selector: 'inbox-appointment-message',
  imports: [MatIconModule, TranslateModule],
  templateUrl: './inbox-appointment-message.component.html',
  styleUrl: './inbox-appointment-message.component.scss',
})
export class InboxAppointmentMessageComponent {
  public readonly booking = input<AppointmentBooking>();

  protected readonly statusKey = computed(() => getAppointmentStatusKey(this.booking()?.status));

  /**
   * The booked slot in the viewer's language and the booking's own timezone. Angular's DatePipe
   * takes only numeric offsets and the inbox's dayjs setup has no timezone plugin, so Intl is the
   * only formatter here that handles an IANA name.
   */
  protected readonly formattedStartTime = computed(() => {
    const booking = this.booking();
    if (!booking?.startTime) {
      return undefined;
    }
    // Meta supplies the timezone, so an unusable name falls back to the viewer's own zone rather
    // than throwing a RangeError that would take the whole message list down with it.
    const timeZone = booking.timezone && isValidTimezone(booking.timezone) ? booking.timezone : undefined;
    return new Intl.DateTimeFormat(this.locale, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      timeZone,
      timeZoneName: 'short',
    }).format(booking.startTime * MILLISECONDS_PER_SECOND);
  });

  private readonly locale = inject(LOCALE_ID);
}
